export default "__VITE_ASSET__763c2f7c__"